import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Nav({ color }: { color?: string }) {
  const [bg, setBg] = useState<string | undefined>("bg-white");
  const [showClearance, setShowClearance] = useState(true);
  const [showSidebar, setSidebar] = useState(false);
  const [showOpts, setOpts] = useState(false);
  const [optClass, setoptClass] = useState({
    icon: "fa-caret-down",
    sect: "opacity-0",
  });
  const handleClearance = () => {
    setShowClearance(!showClearance);
  };
  const handleSidebar = () => {
    setSidebar(!showSidebar);
  };
  const handleOpts = () => {
    setOpts(!showOpts);
    if (showOpts) {
      setoptClass({
        icon: "fa-caret-up",
        sect: "opacity-1",
      });
    } else {
      setoptClass({
        icon: "fa-caret-down",
        sect: "opacity-0",
      });
    }
  };
  useEffect(() => {
    setBg(color);
  });
  console.log(showOpts);

  return (
    <div className="relative z-[60]">
      {showClearance && (
        <div className="bg-black sticky z-30 top-0 text-white p-0.5 w-full flex md:flex-row flex-col-reverse gap-2 md:gap-8 justify-center items-center ">
          <div className="flex items-center gap-3">
            <p className="text-sm uppercase font-medium tracking-wide">
              Clearance Sales up to <span className="font-bold">50%</span> off
            </p>
            <a
              href="/"
              className="text-sm font-bold uppercase text-purple-500 hover:text-purple-400"
            >
              Shop Now
            </a>
          </div>
          <div className="flex w-11/12 md:w-max justify-end">
            <i
              onClick={handleClearance}
              className="fa-solid fa-xmark cursor-pointer text-[17px]"
            ></i>
          </div>
        </div>
      )}
      <div
        className={`h-[7vh] ${
          bg === undefined ? "bg-white" : bg
        } relative py-[2rem] px-4 md:px-[3rem] flex items-center justify-between`}
      >
        <div className="flex items-center gap-6">
          <i
            onClick={handleSidebar}
            className="fa-solid fa-bars-staggered md:hidden block text-lg cursor-pointer"
          ></i>
          <img src={require("../images/BABL.png")} alt="" />
        </div>
        <ul className="hidden md:flex items-center z-[70] gap-4 text-[12px] font-semibold uppercase tracking-wide">
          <Link
            to="/"
            className="cursor-pointer border-b-2 border-transparent hover:border-black"
          >
            Home
          </Link>
          <Link
            to="products"
            className="cursor-pointer border-b-2 border-transparent hover:border-black"
          >
            Products
          </Link>
          <li className="cursor-pointer ab-bt relative border-b-2 border-transparent hover:border-black">
            About us
            <div className="bg-white/60  backdrop-blur-lg ab-links p-0 absolute opacity-1 flex-col left-0 top-5 w-0">
              <p className="cursor-pointer ab-link hidden border-b-2 p-2 w-max border-transparent hover:border-black">
                Our Company
              </p>
              <p className="cursor-pointer ab-link hidden border-b-2 p-2 w-max border-transparent hover:border-black">
                Our Team
              </p>
              <p className="cursor-pointer ab-link hidden border-b-2 p-2 w-max border-transparent hover:border-black">
                Mission
              </p>
              <p className="cursor-pointer ab-link hidden border-b-2 p-2 w-max border-transparent hover:border-black">
                Vision
              </p>
            </div>
          </li>
        </ul>
        <div className="flex gap-[3rem] justify-end items-center">
          <div className="hidden md:flex items-center text-[13px] gap-2 font-medium">
            <p className="cursor-pointer">EN</p>
            <span>|</span>
            <p className="text-black/50 cursor-pointer">FR</p>
          </div>
          <i className="fa-solid fa-bag-shopping text-[23px] md:text-[25px] cursor-pointer hover:!text-black/70"></i>
        </div>
      </div>
      {showSidebar && (
        <motion.div className="w-full h-screen">
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.1, ease: "easeInOut", bounce: 0 }}
            className="bg-white p-8 h-screen flex flex-col gap-6 fixed left-0 z-[70] top-0 min-w-[50%] text-white"
          >
            <i
              onClick={handleSidebar}
              className="fa-solid fa-xmark text-black text-right text-lg cursor-pointer"
            ></i>
            <div>
              <ul className="flex flex-col gap-4 text-black text-[16px] font-semibold uppercase tracking-wide">
                <Link
                  to="/"
                  className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black"
                >
                  Home
                </Link>
                <Link
                  to="products"
                  className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black"
                >
                  Products
                </Link>
                <li
                  onClick={handleOpts}
                  className="cursor-pointer relative p-1 w-max flex items-center gap-6 border-b-2 border-transparent"
                >
                  About us
                  <i className={`fa-solid ${optClass.icon}`}></i>
                  {!showOpts && (
                    <div
                      className={`p-2 w-full text-[15px] font-medium capitalize absolute top-10 left-0 flex flex-col gap-4 text-black ${optClass.sect}`}
                    >
                      <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                        Our Company
                      </p>
                      <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                        Our Team
                      </p>
                      <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                        Mission
                      </p>
                      <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                        Vision
                      </p>
                    </div>
                  )}
                </li>
              </ul>
              {/* {!showOpts && (
              <div className={`p-2 w-full text-[16px] flex flex-col gap-4 text-black ${optClass.sect}`}>
                <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                  Our Company
                </p>
                <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                  Our Team
                </p>
                <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                  Mission
                </p>
                <p className="cursor-pointer border-b-2 p-1 w-max border-transparent hover:border-black">
                  Vision
                </p>
              </div>
            )} */}
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1, ease: "easeOut" }}
            onClick={handleSidebar}
            className="bg-black/20 backdrop-blur-lg fixed p-2 top-0 w-full h-full left-0 z-[60]"
          ></motion.div>
        </motion.div>
      )}
    </div>
  );
}

export default Nav;
